export const environment = {
  version: '1.0',
  production: false,
  env: 'test',
  appName: 'RedJaliscoUI',
  apiURLNew: 'https://acai.test.einteligent.com/WebServices',
};
